//export const HOSTNAME = 'http://meridian.golodkuh.beget.tech/';

//export const HOSTNAME = 'http://evhripd4.beget.tech/';

export const HOSTNAME = 'http://golodkuh.beget.tech/';



// WEBPACK FOOTER //
// ./src/config.js